import { render, staticRenderFns } from "./price-list-card.vue?vue&type=template&id=06cb087e&"
import script from "./price-list-card.vue?vue&type=script&lang=js&"
export * from "./price-list-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports